




































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SectionDialogComponent from '@/components/SectionDialogComponent.vue'
import { Section } from '@/domain/Section'
import SectionsService from '@/service/SectionsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SectionDialogComponent,
  },
})
export default class MasterSectionList extends Mixins(GlobalMixin) {
  sectionsService = SectionsService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "部署コード", value: "code", width: "120px" },
          { text: "部署名", value: "name" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: Section[] = []
  rowItemKey = ""
  rowItemClickTime = 0

  dto: Section =  new Section()
  sectionDialog = false

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Section) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.code) {
      this.onEdit(event.code)
    }
    this.rowItemKey = event.code
    this.rowItemClickTime = now
  }

  /**
   * 新規作成
   */
  onNew() {
    this.sectionsService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.sectionDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.sectionsService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.sectionDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onSectionSubmit(dto: Section) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.sectionsService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.sectionsService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.sectionsService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
